export function getDashboardGreetingKey(timeZone, now = new Date()) {
  let hour;

  try {
    hour = Number(
      new Intl.DateTimeFormat('en-GB', {
        hour: '2-digit',
        hourCycle: 'h23',
        ...(timeZone ? { timeZone } : {}),
      }).format(now),
    );
  } catch {
    hour = now.getHours();
  }

  if (hour < 12) return 'dashboard.greeting.morning';
  if (hour < 17) return 'dashboard.greeting.afternoon';
  return 'dashboard.greeting.evening';
}
